import { EnvironmentProviders, Provider } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { ListingPageService } from 'src/app/shared/components/listing-page/listing-page.service';
import { QueryParamsHandlerService } from 'src/app/shared/components/listing-page/services/query-params-handler/query-params-handler.service';
import { LISTING_MODEL } from 'src/app/shared/constants/tokens';
import * as DevicesListingPageEffects from '../../services/devices-listing-page.effects';
import { devicesMapConfigProvider } from '../../services/devices-map-config.service';
import { SensorsListingFiltersSourceService } from './sensors-listing-filters-source.service';
import { SensorsListingModelService } from './sensors-listing-model.service';

export const provideSensorsListing = (): (Provider | EnvironmentProviders)[] => [
  SensorsListingFiltersSourceService,
  { provide: LISTING_MODEL, useClass: SensorsListingModelService },
  ListingPageService,
  QueryParamsHandlerService,
  provideEffects(DevicesListingPageEffects),
  devicesMapConfigProvider
];
